import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as S from './ProfileOverlay.styles';
import { DropdownMenu } from '@app/components/header/Header/Header.styles';
import { ThemePicker } from '@app/components/header/dropdowns/settingsDropdown/settingsOverlay/ThemePicker/ThemePicker';

export const ProfileOverlay: React.FC = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu selectable={false} {...props}>
      <S.MenuItem key={0}>
        <S.Text>
          <Link to="/profile">{t('profile.title')}</Link>
        </S.Text>
      </S.MenuItem>
      <S.ItemsDivider />
      {/* Light/dark switch. The click is stopped from bubbling so toggling the
          theme does not also close the dropdown -- you usually want to see the
          result before dismissing it. */}
      <S.MenuItem key={1}>
        <S.ThemeRow onClick={(e) => e.stopPropagation()}>
          <S.Text>{t('header.changeTheme')}</S.Text>
          <ThemePicker />
        </S.ThemeRow>
      </S.MenuItem>
      <S.ItemsDivider />
      <S.MenuItem key={2}>
        <S.Text>
          <Link to="/logout">{t('header.logout')}</Link>
        </S.Text>
      </S.MenuItem>
    </DropdownMenu>
  );
};
